define('hadoop/listeners/test-exposure-handlers',['adlhelpers', 'domhelpers', 'doneable'], function(ADL, domHelpers, Doneable) {
    'use strict';

    var cachedExposures = {
        testname: [],
        variant: []
    };

    /**
     * Processes a 'test.exposure' event and send it to Hadoop
     *
     * @throws {TypeError} - if paremeters do not pass validation
     * @param {Object} [hadoop] - Instance of hadoop-wrapper
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     * @param {ADL} [adl] - Instance of an ADL model
     * @param {boolean} [pageviewTriggered] - True when a pageview has been triggered
     * @param {boolean} [finalize] - True when a pageview has been triggered and edap.trigger needs to be called
     * @returns {Doneable} - resolved when the Hadoop send() is complete, or if there was an error
     */
    function processTestExposure(hadoop, edap, adl, pageviewTriggered, finalize) {
        if (!edap || typeof edap.trigger !== 'function') {
            throw new TypeError('processTestExposure(): must pass in an EDAP instance');
        }

        return new Doneable(function(done) {
            if (!hadoop) {
                throw new TypeError('processTestExposure(): hadoop must be set');
            }

            if (!(adl instanceof ADL)) {
                throw new TypeError('processTestExposure(): adl must be an ADLHelpers instance');
            }

            // Push data into the array unless finalized
            if (!finalize) {
                if (!(typeof adl.get('variant') === 'string' && adl.get('testname') && adl.get('variant'))) {
                    throw new ReferenceError('processTestExposure(): event data must contain testname and variant in string format');
                }

                cachedExposures.testname.push(adl.get('testname'));
                cachedExposures.variant.push(adl.get('variant'));
            } else {
                // Only trigger a test.exposure event if there's something to send
                if ((cachedExposures.testname.length && cachedExposures.variant.length)) {
                    // Send with context
                    edap.trigger('test.exposure', {
                        testname: cachedExposures.testname.join(','),
                        variant: cachedExposures.variant.join(',')
                    }).then(function() {
                        // Make sure the same data isn't sent repeatedly
                        cachedExposures.testname = [];
                        cachedExposures.variant = [];
                        done();
                    });
                } else {
                    // pageview has happened without anything to be done for test exposures
                    done();
                }
                return;
            }
            // Test for pageview having been triggered previously or fall through to done()
            if (pageviewTriggered === true) {
                hadoop.send('test.exposure', adl.get(), adl.isSetGet('sessionid'), adl.isSetGet('visitorid')).then(function() {
                    // Make sure the same data isn't sent repeatedly
                    cachedExposures.testname = [];
                    cachedExposures.variant = [];
                    done();
                });
                return;
            }
            done();
        }, {
            error: edap.error
        });
    }

    return {
        processTestExposure: processTestExposure
    };
});

